import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// react bootstrap
import { Container } from 'react-bootstrap'

// styles
import './styles/notifications-styles.scss'

// react toastify
import { toast } from 'react-toastify';

// APIs
import {
    getEmails,
    cancelGetEmailsApi,
    updateEmailStatusApi
} from 'utlis/Apis/Emails_API'
import { getNotificationsDataApi, cancelGetNotificationsDataApi } from 'utlis/Apis/Notifications_API';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_EMAILS,
    EMAIL_STATE_CHANGED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

// imports
import CustomerOrderNotifications from './includes/CustomerOrderNotifications'
import AdminOrderNotifications from './includes/AdminOrderNotifications/AdminOrderNotifications'
import DomainDetails from './includes/DomainDetails/DomainDetails'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function Notifications(props) {
    // props
    const { authState } = props

    // store url    
    const [storeUrl] = useStoreUrl()

    // props
    const {
        history,

        setGlobalLoading,
    } = props

    // consts
    const loadingCount = [1, 2, 3, 4, 5]

    // states
    const [notificationsLoading, setNotificationsLoading] = useState(false)
    const [notificationsList, setNotificationsList] = useState([])
    const [notificationsData, setNotificationsData] = useState(null)

    // getting notifications data
    useEffect(() => {
        // loading
        setNotificationsLoading(true)
        // setGlobalLoading(true)

        // generating url parameters
        let URLParams = `limit=-1`

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }

        Promise.all([
            getEmails(headers, URLParams), // getting emails data
            getNotificationsDataApi(headers), // getting notifications data
        ]).then(res => {
            // loading
            setNotificationsLoading(false);
            // setGlobalLoading(false);

            // emails data
            (function () {
                const resData = res[0].data

                // if request succesfull
                if (resData && resData.success) {
                    // settings emails
                    setNotificationsList(resData.data)
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            })();

            // notifications data
            (function () {
                const resData = res[1].data

                // if request succesfull
                if (resData && resData.success) {
                    setNotificationsData(resData.data) // setting notifications data
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            })();


        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getEmails `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // loading
                    setNotificationsLoading(false);
                    // setGlobalLoading(false);
                }
            })
        })

        return () => { // cancelling the network request if user leaves the page
            cancelGetEmailsApi && cancelGetEmailsApi()
            cancelGetNotificationsDataApi && cancelGetNotificationsDataApi()
        }
    }, [authState, setGlobalLoading])


    // notifications click
    const handleNotificationClick = (ev, tempId) => {
        ev.preventDefault()

        if (tempId) {
            history.push(storeUrl + "/settings/emails/edit/" + tempId)
        }
    }

    // notifications change
    const handleNotificationChange = (ev, tempId) => {
        const isChecked = ev.target.checked

        if (tempId) {
            // loading
            setGlobalLoading(true)

            const copyOfNotificationsList = [...notificationsList]

            const filteredList = notificationsList.map(item => {
                if (item.template_id === tempId) { // if id exist then changing the status
                    return {
                        ...item,
                        status: isChecked ? 1 : 0 // changing the status
                    }
                }
                return item
            })

            setNotificationsList(filteredList) // setting updated list

            const requiredData = {
                status: isChecked ? 1 : 0,
                template_id: tempId
            }
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // getting data
            updateEmailStatusApi(headers, requiredData).then(res => {
                // loading
                setGlobalLoading(false)

                const resData = res.data

                // if request succesfull
                if (resData && resData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(EMAIL_STATE_CHANGED_SUCCESSFULLY, {
                        autoClose: 2500
                    })
                }

                // if request is not succesfull
                if (resData && resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? ERROR_WHILE_FETCHING_EMAILS, {
                        autoClose: 2500,
                        onClose: () => {
                            setNotificationsList(copyOfNotificationsList) // setting notifications list with old data
                        }
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getEmails `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setGlobalLoading(false)

                        setNotificationsList(copyOfNotificationsList) // setting notifications list with old data
                    }
                })
            })
        }
    }


    return (
        <section id="app-notifications" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-notifications">
                    {/* header */}
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Notifications</p>
                        <p className="app-desc">
                            Keep yourself and customers informed with automated notifications. Send order updates, remind customers about your products, and keep up with what’s happening in your store.
                        </p>
                    </div>

                    <div className="app-content-container">

                        {
                            /* fixed page view | DOMAIN SETTINGS */
                            <div className="fixed-left-page-view-container notifications-container">
                                <div className="flpvc-inner d-flex flex-wrap">
                                    {/* left sec */}
                                    <div className="flpvc-lt-sec">
                                        <div className="inner">
                                            {/* heading */}
                                            <div className="app-header-wrapper heading-sm mb-3">
                                                <p className="app-heading text-capitalize mb-2">Domain Settings</p>
                                                <p className="app-desc">
                                                    Manage your domain settings. Edit or add a new domain.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* right sec */}
                                    <div className="flpvc-rt-sec media-body ps-3">
                                        <div className="inner">
                                            <DomainDetails
                                                loading={notificationsLoading}

                                                notificationsData={notificationsData}
                                                setNotificationsData={setNotificationsData}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {/* fixed page view | CUSTOMER NOTIFICATIONS */}
                        <div className="fixed-left-page-view-container notifications-container">
                            <div className="flpvc-inner d-flex flex-wrap">
                                {/* left sec */}
                                <div className="flpvc-lt-sec">
                                    <div className="inner">
                                        {/* heading */}
                                        <div className="app-header-wrapper heading-sm mb-3">
                                            <p className="app-heading text-capitalize mb-2">Customer notifications settings</p>
                                            <p className="app-desc">
                                                Manage email notifications that are automatically sent to customers. Edit, enable or disable them depending on your business needs.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* right sec */}
                                <div className="flpvc-rt-sec media-body ps-3">
                                    <div className="inner">
                                        <CustomerOrderNotifications
                                            notificationsData={notificationsData}
                                            setNotificationsData={setNotificationsData}

                                            loading={notificationsLoading}
                                            loadingCount={loadingCount}

                                            notificationsList={notificationsList}

                                            handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                                            handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* fixed page view | ADMIN NOTIFICATIONS */}
                        <div className="fixed-left-page-view-container notifications-container">
                            <div className="flpvc-inner d-flex flex-wrap">
                                {/* left sec */}
                                <div className="flpvc-lt-sec">
                                    <div className="inner">
                                        {/* heading */}
                                        <div className="app-header-wrapper heading-sm mb-3">
                                            <p className="app-heading text-capitalize mb-2">Admin notifications settings</p>
                                            <p className="app-desc">
                                                Manage automated email notifications that are sent to you and staff members you specify. Edit, enable or disable them depending on your business needs.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* right sec */}
                                <div className="flpvc-rt-sec media-body ps-3">
                                    <div className="inner">
                                        <AdminOrderNotifications
                                            notificationsData={notificationsData}
                                            setNotificationsData={setNotificationsData}

                                            loading={notificationsLoading}
                                            loadingCount={loadingCount}

                                            notificationsList={notificationsList}

                                            handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                                            handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Notifications)